import * as React from "react";

interface SectionLoaderProps {
  count?: number;
  className?: string;
}

export const SectionLoader: React.FC<SectionLoaderProps> = ({ count = 4, className = "health-section-grid" }) => {
  return (
    <div className={className}>
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="rounded-lg p-4 animate-pulse"
          style={{ backgroundColor: "var(--color-drop)", border: "1px solid var(--color-border)" }}
        >
          <div
            className="h-4 rounded mb-3"
            style={{ backgroundColor: "var(--color-border)", width: "60%" }}
          />
          <div className="h-8 rounded" style={{ backgroundColor: "var(--color-border)" }} />
        </div>
      ))}
    </div>
  );
};
